import {
  CLASS_RESULT_NOTICE_LINK,
  sessionData,
  meiroEvents,
} from '@box/article/EnquiryBars/enquiryCommons';
import { hasDataLayer } from '@utils/dataLayer';

/**
 * @name showLoginLink
 * @description Zobrazí zprávu pro uživatele s odkazem na přihlášení a potvrzení přijetí hlasu ankety.
 *
 * @param {HTMLElement} enquiry Element ankety.
 * @param {HTMLElement} answersWrapper Element obalující všechny odpovědi.
 * @param {HTMLElement} voteNotice Element pro potvrzení přijetí hlasu.
 * @param {String} questionId Identifikátor odpovědi.
 * @param {String} questionText Text odpovědi.
 * @param {Boolean} enquiryEnabled Status ankety.
 */
const showLoginLink = (
  enquiry: HTMLElement,
  answersWrapper: HTMLElement,
  voteNotice: HTMLElement,
  questionId: string,
  questionText: string,
  enquiryEnabled: boolean
) => {
  answersWrapper.insertAdjacentHTML(
    'beforebegin',
    `
  <div class="enquiry-bars__result-notice">
    <div class="enquiry-bars-result-notice__text">${
      enquiryEnabled ? 'Děkujeme za hlasování.' : 'Hlasování již skončilo.'
    } Pro zobrazení výsledků se, prosím, přihlaste.</div>
    <a href="/prihlaseni"
       class="button button--button button--lg button--primary button--normal button--contained button--gradient load-more-btn ${CLASS_RESULT_NOTICE_LINK}"
       title="Přihlásit se"
    >
       <span class="typography typography--button-lg button__text">Přihlásit se</span>
    </a>
  </div>
`
  );

  (enquiry.querySelector(`.${CLASS_RESULT_NOTICE_LINK}`) as HTMLElement).addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      sessionData.setItem('userLoggingFrom', questionId);

      if (hasDataLayer() && window.didomiOnReady !== undefined) {
        void window.dataLayer.push({
          event: 'user_login_start',
          login: {
            source: 'anketa',
          },
        });
      }

      if (meiroEvents) {
        meiroEvents.track('customEvent', {
          action: `poll login clicked: ${questionText}`,
        });
      }

      window.location.href = (event.currentTarget as HTMLAnchorElement).getAttribute(
        'href'
      ) as string;
    }
  );

  answersWrapper.remove();
  if (enquiryEnabled) {
    voteNotice.innerText = 'Váš hlas byl započítán';
  }
};

export default showLoginLink;
